export enum ProjectTypesEnum {
  ADDITIONAL = 'ADDITIONAL',
  INVEST = 'INVEST'
}
